import { render, staticRenderFns } from "./pautaTrimestral.vue?vue&type=template&id=4284a657&"
import script from "./pautaTrimestral.vue?vue&type=script&lang=js&"
export * from "./pautaTrimestral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports